import { Component, OnInit } from '@angular/core';
import { CustomLayoutService } from '@app/services/custom-layout.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout-form',
  templateUrl: './layout-form.component.html',
  styleUrl: './layout-form.component.scss'
})
export class LayoutFormComponent implements OnInit {


  shortcode = '';
  description = '';
  LayoutRemarks = '';
  customLayouts: any[] = [];
  selectedCustomLayout: string = '';
  useExistingLines = false;
  /** Layout line rows (always an array for saveLayout details). */
  LayoutLinesArr: any[] = [];
  isEditMode = false;
  finalLayoutLinesArr: any[] = [];

  constructor(private customLayoutService: CustomLayoutService, private router: Router) { }

  ngOnInit() {
    this.customLayoutService.getcustomLayoutList().subscribe(data => {
      this.customLayouts = Array.isArray(data) ? data : [];
    });

    const navigation = history.state;
    if (navigation && navigation.editCustomLayout) {
      const editCustomLayout = navigation.editCustomLayout;
      this.isEditMode = true;
      this.shortcode = editCustomLayout.LayoutShortCode;
      this.description = editCustomLayout.LayoutDescription;
      this.LayoutRemarks = editCustomLayout.LayoutRemarks;

      const lines = editCustomLayout.LayoutLinesArr ?? editCustomLayout.details ?? [];
      this.LayoutLinesArr = Array.isArray(lines) ? lines : [];
      this.useExistingLines = true; // show template selection for clarity if needed
    }
  }

  saveLayout() {
    if (this.useExistingLines) {
      if (this.isEditMode) {
        this.finalLayoutLinesArr = Array.isArray(this.LayoutLinesArr) ? this.LayoutLinesArr : [];
        this.persistLayout();
        return;
      }
      if (this.selectedCustomLayout) {
        this.customLayoutService.getcustomLayoutLinesByShortCode(this.selectedCustomLayout).subscribe({
          next: (data) => {
            this.finalLayoutLinesArr = this.cloneLinesForNewLayout(data);
            this.persistLayout();
          },
          error: () => {
            this.finalLayoutLinesArr = [];
            this.persistLayout();
          },
        });
        return;
      }
    }
    this.finalLayoutLinesArr = Array.isArray(this.finalLayoutLinesArr) ? this.finalLayoutLinesArr : [];
    this.persistLayout();
  }

  private persistLayout(): void {
    const newLayout = {
      LayoutShortCode: this.shortcode,
      LayoutDescription: this.description,
      LayoutRemarks: this.LayoutRemarks,
      details: Array.isArray(this.finalLayoutLinesArr) ? this.finalLayoutLinesArr : [],
    };
    this.customLayoutService.savecustomLayout(newLayout).subscribe(() => {
      this.router.navigate(['/designer/layout-list']);
    });
  }

  private cloneLinesForNewLayout(lines: unknown): any[] {
    if (!Array.isArray(lines)) return [];
    return lines.map((line) => ({
      ...line,
      LayoutShortCode: this.shortcode,
    }));
  }
}
